// Maintenance mode config — automatically disables itself after `endsAt`.
// Path-based bypass keeps admin reachable; query-param bypass for your own preview.

// Maintenance mode active until 23:59 IST on 28 May 2026 (2 days from 26 May 2026).
// After this timestamp, the site automatically resumes normal operation — no redeploy needed.
export const MAINTENANCE_ENDS_AT = new Date('2026-05-28T18:30:00Z'); // 28 May 2026, 23:59 IST

// Admin routes always remain accessible so you can manage content during downtime.
export const ADMIN_BYPASS_PREFIXES = ['/admin'];

// Secret query parameter for your own preview. Visit
// https://vidya365.in/?preview=v365  → bypass is stored in sessionStorage.
export const BYPASS_QUERY_PARAM = 'preview';
export const BYPASS_QUERY_VALUE = 'v365';

export const isMaintenanceActive = () => {
  if (typeof window === 'undefined') return false;
  // Time check
  if (new Date() > MAINTENANCE_ENDS_AT) return false;
  // Admin route bypass
  const path = window.location.pathname || '/';
  if (ADMIN_BYPASS_PREFIXES.some((p) => path.startsWith(p))) return false;
  // Query-param bypass (sticky via sessionStorage)
  try {
    const params = new URLSearchParams(window.location.search);
    if (params.get(BYPASS_QUERY_PARAM) === BYPASS_QUERY_VALUE) {
      sessionStorage.setItem('v365-maintenance-bypass', '1');
      return false;
    }
    if (sessionStorage.getItem('v365-maintenance-bypass') === '1') return false;
  } catch (e) { /* sessionStorage unavailable */ }
  return true;
};
